import { defineStore } from "pinia";
import Services from '@/services/beneficiaryServices'
import { mapBeneficiary } from '@/helpers/mapFuncs'
import { assertPersonTypeRange } from '@/helpers/personTypeGuard'

export const useBeneficiaryStore = defineStore("beneficiary", {

state:()=>({
    beneficiary: {},
    beneficiaries: [],
}),
getters : {
    getBeneficiary() {
        return mapBeneficiary(this.beneficiary)
    },
    getBeneficiaries() {
        return this.beneficiaries.map(mapBeneficiary)
    }
},
actions : {
    /** Start Sets */
    setBeneficiary(beneficiary) {
        this.beneficiary = beneficiary
    },
    setBeneficiaries(beneficiaries) {
        this.beneficiaries = beneficiaries
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setBeneficiary(response.data.data)
            return response
        })
    },
    getProfileDataByPersonId(id) {
        return Services.getProfileDataByPersonId(id)
        .then((response)=>{
            let data = { ...response.data.data.beneficiary , ...response.data.data, members: response.data.data.familyMembers.member, sacrificer: response.data.data.familyMembers.sacrificer };
            assertPersonTypeRange(
                data,
                4,
                6
            )
            this.setBeneficiary(data)
            return response
        })
    },
    addWife(personId, relationship, data){
        return Services.addWife(personId, relationship, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    addStepmother(personId, relationship, fatherId, data){
        return Services.addStepmother(personId, relationship, fatherId, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    addSonWife(personId, relationship, husbandId, data){
        return Services.addSonWife(personId, relationship, husbandId, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    addSibling(personId, relationship, fatherId, motherId, data){
        return Services.addSibling(personId, relationship, fatherId, motherId, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    addMother(personId, relationship, data){
        return Services.addMother(personId, relationship, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    addGrandchildren(personId, relationship, fatherID, motherId, data){
        return Services.addGrandchildren(personId, relationship, fatherID, motherId, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    addFather(personId, relationship, data){
        return Services.addFather(personId, relationship, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    addChildren(personId, relationship, motherId, data){
        return Services.addChildren(personId, relationship, motherId, data)
        .then((response)=>{
            this.beneficiaries.push(response.data.data)
            return mapBeneficiary(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.beneficiaries[this.beneficiaries.findIndex((x)=>x.id == id)] = response.data.data?.person
            return mapBeneficiary(response.data.data?.person)
        })
    },

     delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.beneficiaries = this.beneficiaries.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});